import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Features', path: '#features' },
      { label: 'Examples', path: '#examples' },
      { label: 'Pricing', path: '#pricing' },
      { label: 'Documentation', path: '#docs' }
    ],
    company: [
      { label: 'About Us', path: '#about' },
      { label: 'Blog', path: '#blog' },
      { label: 'Careers', path: '#careers' },
      { label: 'Contact', path: '#contact' }
    ],
    resources: [
      { label: 'Help Center', path: '#help' },
      { label: 'API Reference', path: '#api' },
      { label: 'Community', path: '#community' },
      { label: 'Status', path: '#status' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '#privacy' },
      { label: 'Terms of Service', path: '#terms' },
      { label: 'Cookie Policy', path: '#cookies' },
      { label: 'Security', path: '#security' }
    ]
  };

  const socialLinks = [
    { icon: 'Github', label: 'GitHub', url: '#github' },
    { icon: 'Twitter', label: 'Twitter', url: '#twitter' },
    { icon: 'Linkedin', label: 'LinkedIn', url: '#linkedin' },
    { icon: 'Youtube', label: 'YouTube', url: '#youtube' }
  ];

  return (
    <footer className="bg-card border-t border-border py-10 md:py-14 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-10 lg:gap-12 mb-10 md:mb-12 lg:mb-14">
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <Link to="/landing-page" className="inline-flex items-center gap-3 mb-4 md:mb-5 lg:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <Icon name="Code2" size={24} color="#FFFFFF" />
              </div>
              <span className="text-xl md:text-2xl font-semibold text-foreground">Giati Builder</span>
            </Link>
            <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-5 lg:mb-6 leading-relaxed max-w-sm">
              Transform your ideas into production-ready code with AI-powered generation. Build faster, ship sooner.
            </p>
            <div className="flex gap-3 md:gap-4">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  aria-label={social?.label}
                  className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-all duration-300"
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4 lg:mb-5">Product</h3>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4 lg:mb-5">Company</h3>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4 lg:mb-5">Resources</h3>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks?.resources?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4 lg:mb-5">Legal</h3>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
            <p className="text-xs md:text-sm text-muted-foreground text-center md:text-left">
              &copy; {currentYear} Giati Builder. All rights reserved.
            </p>
            <div className="flex items-center gap-4 md:gap-6">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} className="text-success" />
                <span className="text-xs md:text-sm text-muted-foreground">SSL Secured</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Award" size={16} className="text-success" />
                <span className="text-xs md:text-sm text-muted-foreground">SOC 2 Certified</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;